import { SpinnerIcon } from "@phosphor-icons/react"
import { cn } from "../lib/utils"

function Spinner({ className, weight = "regular", ...props }: React.ComponentProps<"svg"> & { weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone" }) {
  return (
    <SpinnerIcon
      weight={weight}
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)} {...props}
    />
  )
}

export { Spinner }
